import { unit } from '../../v2/foundation/spacing/utils.js';

var getSizeFromProps = function getSizeFromProps(props) {
  return unit(props.$size);
};
var getPrimaryColorFromProps = function getPrimaryColorFromProps(props) {
  return props.$primaryColor;
};
var getSrcFromProps = function getSrcFromProps(props) {
  return props.$src;
};
var getAlignmentFromProps = function getAlignmentFromProps(props) {
  return props.$alignment;
};

export { getAlignmentFromProps, getPrimaryColorFromProps, getSizeFromProps, getSrcFromProps };
